import React, { Component } from "react";

import TextField from "@material-ui/core/TextField";

class DurationField extends Component {
  constructor() {
    super();

    this.state = {
      value: 0,
    };
  }


  onChange = (e) => {
    this.setState({
      value: e.target.value,
    });

    this.props.onChange({
      target: {
        value: `${e.target.value}s`,
        type: "text",
        id: this.props.id,
      },
    });
  }

  componentDidMount() {
    setTimeout(() => {
      const str = this.props.value || "";
      this.setState({
        value: str.replace(/s/, ''),
      });
    }, 500)
  }

  render() {
    return(
      <TextField
        type="number"
        id={this.props.id}
        label={this.props.label}
        value={this.state.value}
        helperText={this.props.helperText}
        margin="normal"
        onChange={this.onChange}
        required
        fullWidth
        disabled={this.props.disabled}
      />
    );
  }
}

export default DurationField;

